import * as yup from 'yup'

export default function passwordSchema() {
  return yup
    .string()
    .required('${label} requis')
    .min(12, 'Le mot de passe doit contenir au moins ${min} caractères')
    .matches(/[a-z]/, 'Le mot de passe doit contenir au moins une lettre minuscule')
    .matches(/[A-Z]/, 'Le mot de passe doit contenir au moins une lettre majuscule')
    .matches(/\d/, 'Le mot de passe doit contenir au moins un chiffre')
    .matches(/[!"#$%&'()*+,\-./:;<=>?@[\]_`{}~]/, 'Le mot de passe doit contenir au moins un caractère spécial')
    .label('Mot de passe')
}
